import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fb01b81&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb01b81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb01b81')) {
      api.createRecord('0fb01b81', component.options)
    } else {
      api.reload('0fb01b81', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fb01b81&scoped=true&", function () {
      api.rerender('0fb01b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchFileDownload/index.vue"
export default component.exports